import { render } from "./resultpage.vue?vue&type=template&id=f0d0f55c"
import script from "./resultpage.vue?vue&type=script&lang=js"
export * from "./resultpage.vue?vue&type=script&lang=js"

import "./resultpage.vue?vue&type=style&index=0&id=f0d0f55c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__